"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenObject = exports.setObjectProperty = exports.getObjectProperty = exports.getValue = void 0;
const isPlaceholder = (prop) => prop.slice(0, 2) === '${' && prop.slice(prop.length - 1) === '}';
function getValue(obj, prop, originalObj = {}) {
    return obj[isPlaceholder(prop) ? originalObj[prop.slice(2, prop.length - 1)] : prop];
}
exports.getValue = getValue;
function getObjectProperty(obj, prop, originalObj) {
    const [first, ...nested] = prop.split('.');
    const value = getValue(obj, first, originalObj !== null && originalObj !== void 0 ? originalObj : obj);
    if (!value)
        return value;
    return nested.length ? getObjectProperty(value, nested.join('.'), originalObj !== null && originalObj !== void 0 ? originalObj : obj) : value;
}
exports.getObjectProperty = getObjectProperty;
function setObjectProperty(obj, prop, value) {
    var _a, _b;
    let [first, ...nested] = prop.split('.');
    const nestedValue = nested.length ? setObjectProperty((_a = obj[first]) !== null && _a !== void 0 ? _a : {}, nested.join('.'), value) : value;
    if (Array.isArray(obj)) {
        const arrayToUpdate = [...obj];
        arrayToUpdate[Number(first)] = nestedValue;
        return arrayToUpdate;
    }
    else {
        return Object.assign(Object.assign({}, obj), { [first]: nested.length ? setObjectProperty((_b = obj[first]) !== null && _b !== void 0 ? _b : {}, nested.join('.'), value) : value });
    }
}
exports.setObjectProperty = setObjectProperty;
function flattenObject(value, prefix) {
    if (value !== null && typeof value === 'object') {
        return Object.entries(value).reduce((soFar, entry) => {
            const [key, val] = entry;
            return soFar.concat(flattenObject(val, prefix ? [prefix, key].join('.') : key));
        }, []);
    }
    return [[prefix, value]];
}
exports.flattenObject = flattenObject;
